import IoniconsFont from '@expo/vector-icons/Ionicons';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';

import 'react-native-gesture-handler';
import iconFont from '@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/Ionicons.ttf';
// import { enableFreeze } from 'react-native-screens';
// import "setimmediate"
// enableFreeze(true);

const iconFontStyles = `@font-face {
  src: url(${iconFont});
  font-family: Ionicons;
}`;

const style = document.createElement('style');
style.type = 'text/css';

if (style.styleSheet) {
  style.styleSheet.cssText = iconFontStyles;
} else {
  style.appendChild(document.createTextNode(iconFontStyles));
}

// Inject stylesheet
document.head.appendChild(style);
import App from './src/App';
import { createElement } from 'react';
import { createRoot } from 'react-dom/client'
import { initUserData } from './src/api';
// return
initUserData().then(()=>{
  const root = createRoot(document.getElementById('root'))
  root.render(createElement(App))
})